import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "c-ticker" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "c-ticker__title" }, "お知らせ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_swiper, {
      modules: _ctx.swiperModules,
      autoplay: {delay: 5000},
      loop: "",
      class: "c-ticker__body"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listNewsContents, (news, i) => {
          return (_openBlock(), _createBlock(_component_swiper_slide, {
            key: i,
            class: _normalizeClass({'is-rg': (news.companyId == 'users')})
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: { path: '/news' } }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(news.title), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["class"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modules"])
  ]))
}